import { useField } from 'formik';
import QuillDelta from 'quill-delta';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Paragraph, QuillInput, QuillText } from '@treams/treams-ui';

export default function OpenQuestion(props: {
	name: string;
	item: graphql.EvaluationOpenQuestionItem;
	readonly?: boolean;
}) {
	const { localize } = useLocalize();

	const [field, , { setValue }] = useField<QuillDelta>(props.name + '.openQuestion');
	const value = field.value ?? new QuillDelta({ ops: [] });

	const { t } = useTranslation();

	return (
		<>
			<Box maxWidth={600}>
				<Paragraph>{localize(props.item.title).text}</Paragraph>
			</Box>
			<Box mt={3}>
				{props.readonly ? (
					<QuillText value={value} placeholder={t('evaluation.submission.openQuestion.empty')} />
				) : (
					<QuillInput value={value} onChange={setValue} />
				)}
			</Box>
		</>
	);
}
